var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"shop-car-steps flex text-center"},_vm._l((_vm.list),function(item,index){return _c('div',{key:index,staticClass:"shop-car-step pointer",class:[
      {'active': index === _vm.step },
      {'is-done': index < _vm.step},
    ]},[_c('p',{staticClass:"shop-car-step-number after relative"},[_c('span',{staticClass:"index"},[_vm._v(_vm._s(index+1))])]),_c('p',{staticClass:"step-label"},[_vm._v(_vm._s(index+1)+"."+_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }